exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item-info[data-v-9518369c] {\n  float:left;\n  width:38px;\n  height:38px;\n  margin-left:6px\n}\n.item-img[data-v-9518369c] {\n  cursor:pointer;\n  position: static;\n  display: block;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);

// exports
